<!-- youtube-mobile-04 preview — YouTube home feed, portrait image in a square player -->
<app-mobile-frame>
  <app-youtube-mobile-navbar frameTop></app-youtube-mobile-navbar>

  <!-- START: Feed -->
  <div class="yt-m-feed">
    <!-- START: Real ad -->
    <div class="yt-m-card">
      <a class="yt-m-player d-block" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
        <ng-container *ngIf="creativeImage; else missing">
          <img class="yt-m-player-blur" [src]="creativeImage" alt="" />
          <img class="yt-m-player-image" [src]="creativeImage" alt="" />
        </ng-container>
        <ng-template #missing>
          <div class="yt-m-player-missing">{{ missingDimensionLabel }}</div>
        </ng-template>

        <span class="yt-m-player-channel d-flex flex-row align-items-center gap-2">
          <img
            class="yt-m-player-logo"
            src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
            alt=""
          />
          <span class="yt-m-player-channel-text d-flex flex-column">
            <strong>{{ data.headlines[0] || "Your headline appears here" }}</strong>
            <small>Valamar</small>
          </span>
        </span>
        <i class="bi bi-info-circle-fill yt-m-player-info"></i>

        <app-youtube-shorts-logo class="yt-m-player-play"></app-youtube-shorts-logo>
        <span class="yt-m-player-link"><i class="bi bi-link-45deg"></i></span>
        <span class="yt-m-player-time">0:00</span>
      </a>

      <div class="yt-m-info d-flex flex-row gap-2">
        <img
          class="yt-m-avatar"
          src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
          alt=""
        />
        <div class="yt-m-info-text">
          <h4 class="yt-m-title">
            {{ data.longHeadlines[0] || "Your long headline appears here" }}
          </h4>
          <div class="yt-m-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>
          <div class="yt-m-meta">
            <strong>Sponsored</strong> &middot; Valamar
          </div>
        </div>
        <i class="bi bi-three-dots-vertical yt-m-more"></i>
      </div>

      <div class="yt-m-buttons d-flex flex-row gap-2">
        <a class="yt-m-btn yt-m-btn-outline" [href]="data.url || null" target="_blank" rel="noopener noreferrer">Pogledajte</a>
        <a class="yt-m-btn yt-m-btn-fill" [href]="data.url || null" target="_blank" rel="noopener noreferrer">{{
          data.ctaText || "Your call to action"
        }}</a>
      </div>
    </div>
    <!-- END: Real ad -->

    <div class="yt-m-rest"></div>
  </div>
  <!-- END: Feed -->

  <app-youtube-mobile-bottom-nav frameBottom></app-youtube-mobile-bottom-nav>
</app-mobile-frame>
